import { Activity, BarChart3, RefreshCcw, Gauge, ShieldCheck, Users, Star } from "lucide-react";

export const ICONS = { build: Activity, lifetime: BarChart3, rep: RefreshCcw, overall: Gauge, badges: ShieldCheck, accounts: Users, star: Star };

export function ServiceIcon({ name, className = "w-9 h-9" }) {
  const I = ICONS[name] || Star;
  return <I className={className} strokeWidth={2.2} />;
}

export function Logo({ className = "" }) {
  return (
    <span className={`font-display text-2xl sm:text-[1.7rem] tracking-tight ${className}`} data-testid="brand-logo">
      <span className="text-metal">RUSH</span>
      <span className="text-electric">GRIND</span>
      <span className="text-metal">2K</span>
    </span>
  );
}

export function SectionHead({ eyebrow, white, blue, desc, center = true, stacked = false, testid }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl`} data-testid={testid}>
      {eyebrow && (
        <div className={`flex items-center gap-4 ${center ? "justify-center" : ""} mb-3`}>
          {center && <span className="hidden sm:block w-14 glow-line" />}
          <span className="eyebrow">{eyebrow}</span>
          {center && <span className="hidden sm:block w-14 glow-line" />}
        </div>
      )}
      <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl">
        <span className="text-metal">{white}</span>
        {stacked ? <br /> : " "}
        <span className="text-electric">{blue}</span>
      </h2>
      {desc && <p className="mt-4 text-base md:text-lg text-slate-300/90">{desc}</p>}
    </div>
  );
}
